export const getBudgetVsLyValue = (params, inPercent = false) => {
  const forecastTotalColumn = params.api.getColumn("forecast_total");
  const forecastTotalValue =
    forecastTotalColumn?.colDef?.valueFormatter?.({
      data: params.data,
    }) || 0;

  const budgetTotalColumn = params.api.getColumn("budget_total");
  const budgetTotalValue =
    budgetTotalColumn?.colDef?.valueFormatter?.({
      data: params.data,
    }) || 0;

  if (inPercent) {
    return forecastTotalValue !== 0
      ? parseFloat(
          (
            ((budgetTotalValue - forecastTotalValue) / budgetTotalValue) *
            100
          ).toFixed(2),
        )
      : 0;
  }

  return budgetTotalValue - forecastTotalValue;
};
